export default __webpack_public_path__ + "static/media/eco-score-B.ab0ba795.svg";